module.exports = __webpack_public_path__ + "img/error@2x.4f3f51be.svg";